import { configureVideoControls, Controls } from '@statsbomb/video-client-js';

export const defaultVideoControls = configureVideoControls({
  controlsToIncludeInAdditionToDefault: [Controls.SaveCurrentlyPlaying],
});
